import { defineStore } from 'pinia';
import { ref } from 'vue';
import { IPagination } from './ApiResponse';

interface IPaginationSetup {
  local?: boolean;
}

interface IPaginationDefinition {
  (): IPaginationInstance;
}

export interface IPaginationInstance {
  get(): IPagination | null;
  set(pagination: IPagination): void;
  clear(): void;
}

function defineGlobalPagination(name: string): IPaginationDefinition {
  const useStore = defineStore(name + 'Pagination', () => {
    const pagination = ref<IPagination | null>(null);

    return {
      pagination,
    };
  });

  return function useGlobalPagination() {
    const store = useStore();

    function get(): IPagination | null {
      return store.pagination;
    }

    function set(pagination: IPagination | null): void {
      store.pagination = pagination;
    }

    function clear(): void {
      set(null);
    }

    return {
      get,
      set,
      clear,
    };
  }
}

function defineLocalPagination(): IPaginationDefinition {
  return () => {
    const _pagination = ref<IPagination | null>(null);

    function get(): IPagination | null {
      return _pagination.value;
    }

    function set(pagination: IPagination | null): void {
      _pagination.value = pagination;
    }

    function clear(): void {
      set(null);
    }

    return {
      get,
      set,
      clear,
    };
  };
}

export function definePagination(name: string, setup?: IPaginationSetup): IPaginationDefinition {
  return setup?.local
    ? defineLocalPagination()
    : defineGlobalPagination(name);
}
